module.exports = __webpack_public_path__ + "img/history.86efcbc2.png";